import React from "react";
import { QuoteIcon } from "lucide-react";
import { Section, SectionHeading } from "../Section";
import { CTAButton } from "../CTAButton";
import { wonderingQuestions } from "../../data/content";
export function Wondering() {
  return <Section tone="white" data-id="element-290" data-mp="11w3thfmmftlv">
      <SectionHeading kicker="6 premium volumes + 5 bonus kits" data-id="element-291" data-mp="11ygbfssdq3yx">
        The complete Nail Course In A Box™ system
      </SectionHeading>

      <p className="mt-10 text-center text-[18px] font-semibold text-ink" data-id="element-292" data-mp="976h1t53cr11">If you've ever spent hours wondering:</p>
      <ul className="mt-5 space-y-3" data-id="element-293" data-mp="4a6j65ieaul0">
        {wonderingQuestions.map(q => <li key={q} className="flex items-start gap-3 rounded-2xl bg-blush px-4 py-4" data-id="element-294" data-mp="i8wf3hthao7s">
            <QuoteIcon className="mt-0.5 h-5 w-5 shrink-0 text-berry" aria-hidden="true" data-id="element-295" data-mp="e6jc316494ep" />
            <span className="font-serif text-[19px] italic leading-snug text-ink" data-id="element-296" data-mp="1tnjjzkrau0hd">“{q}”</span>
          </li>)}
      </ul>

      <div className="mt-10 space-y-4 text-center text-[17px] leading-relaxed text-muted" data-id="element-297" data-mp="1pl6f0ykdm6ln">
        <p className="font-serif text-[24px] font-bold text-berry" data-id="element-298" data-mp="mybny9rxqcie">I created Nail Course In A Box™ for you.</p>
        <p data-id="element-299" data-mp="rx50nzzedzhi">
          You don't need to spend your evenings designing pages, organizing lessons or trying to figure out what your
          students should receive.
        </p>
        <p className="font-semibold text-ink" data-id="element-300" data-mp="10zeb6puo1suw">I've already created the structure.</p>
        <p data-id="element-301" data-mp="4959x023692x">You simply customize it with your name, logo, colors and teaching style.</p>
      </div>

      <CTAButton label="I want Nail Course In A Box™" note="Instant digital access · Canva Free compatible · Editable on phone or computer" data-id="element-302" data-mp="8a7bhnjh6x82" />
    </Section>;
}